import { useCallback, useRef, useState } from 'react';
const useLongPress = (onLongPress, onClick, { shouldPreventDefault = false, delay = 300 } = {}) => {
    const [longPressTriggered, setLongPressTriggered] = useState(false);
    const timeout = useRef();
    const target = useRef(null);
    const start = useCallback((event) => {
        if (shouldPreventDefault && event.target) {
            event.target.addEventListener('touchend', preventDefault, {
                passive: false
            });
            target.current = event.target;
        }
        timeout.current = window.setTimeout(() => {
            onLongPress();
            setLongPressTriggered(true);
        }, delay);
    }, [onLongPress, delay, shouldPreventDefault]);
    const clear = useCallback((event) => {
        if (timeout.current) {
            clearTimeout(timeout.current);
            timeout.current = undefined;
        }
        setLongPressTriggered(false);
        if (shouldPreventDefault && target.current) {
            target.current.removeEventListener('touchend', preventDefault);
            target.current = null;
        }
    }, [shouldPreventDefault, onClick, longPressTriggered]);
    return {
        onMouseDown: (e) => start(e),
        onTouchStart: (e) => start(e),
        onMouseUp: (e) => clear(e),
        onMouseLeave: (e) => clear(e),
        onTouchEnd: (e) => clear(e),
        onClick(e) {
            onClick();
        }
    };
};
const preventDefault = (event) => {
    if (!('touches' in event))
        return;
    const touchEvent = event;
    if (touchEvent.touches.length < 2 && event.preventDefault) {
        event.preventDefault();
    }
};
export default useLongPress;
